import { $fetch } from '@/boot/fetch'

const ENDPOINT = '/users/account/delete'

export default {
  /**
   * Submit an account deletion request
   * @param {object} data
   * @param {string} data.platform - 'ANDROID', 'IOS', or 'WEB'
   * @param {string} [data.reason] - Optional reason for deletion
   * @returns {Promise}
   */
  createRequest(data) {
    return $fetch.peg(`${ENDPOINT}`, {
      method: 'POST',
      body: data,
    })
  },

  /**
   * Get current deletion request status
   * @returns {Promise} - Returns pending request details or null
   */
  getStatus() {
    return $fetch.peg(`${ENDPOINT}`)
  },
}
